<template>
<div>
    <v-toolbar flat color="white" v-if="allShowOfInterest.count>0">
        <v-tabs>
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab v-for="tab of mainTabs" :key="tab.name" @click="selectedMainTab=tab.name">
                {{tab.displayName}}
                <v-chip color="green" v-if="tab.name == 'orders'" class="white--text">
                    {{allActiveOrders.count + allPendingActivation.count}}
                </v-chip>
                <v-chip color="blue" v-else-if="tab.name == 'showOfInterest'" class="white--text">
                    {{allShowOfInterest.count}}
                </v-chip>
                <v-chip color="red" v-if="tab.name == 'rejected'" class="white--text">
                    {{allRejectedOrders.count}}
                </v-chip>
            </v-tab>
        </v-tabs>
    </v-toolbar>
    <div v-if="displayMainTab('orders')">
        <v-toolbar flat color="white">
            <v-tabs>
                <v-tabs-slider color="primary"></v-tabs-slider>
                <v-tab v-for="tab of orderSubTabs" :key="tab.name" @click="selectedOrderSubTab=tab.name">
                    {{tab.displayName}}
                    <v-chip :color="tab.name=='pendingActivation'?'light-blue':'green'" class="white--text" v-if="getOpenOrderCount(tab.name)>0">
                        {{getOpenOrderCount(tab.name)}}
                    </v-chip>
                </v-tab>
            </v-tabs>
        </v-toolbar>
        <!-- <v-toolbar>
           <v-btn @click="applicationModal=true" color="primary" round class="white--text">Add Order</v-btn>
        </v-toolbar> -->
        <v-toolbar :key="selectedOrderSubTab" flat color="white" v-if="selectedOrderSubTab!='completed'">
            <div>
                <!-- <applicationpagemodal @submitComplete="fetchOrders()"></applicationpagemodal> -->
                <v-btn @click="applicationModal=true" :color="$store.state.currentOrg.org.primaryColour" round class="white--text">Add Order</v-btn>
            </div>
            <v-btn class="white--text" :color="$store.state.currentOrg.org.primaryColour" round @click="exportCompletedData()">Export Completed Orders</v-btn>
            <v-spacer></v-spacer>
            <v-text-field label="Search" outlined dense v-model="searchOrders"></v-text-field>
        </v-toolbar>
        <v-toolbar :key="selectedOrderSubTab" flat color="white" v-if="selectedOrderSubTab=='completed'">
            <div>
                <!-- <applicationpagemodal @submitComplete="fetchOrders()"></applicationpagemodal> -->
                <v-btn @click="applicationModal=true" color="primary" round class="white--text">Add Order</v-btn>
            </div>
            <v-btn class="white--text" :color="$store.state.currentOrg.org.primaryColour" round @click="exportCompletedData()">Export Completed Orders</v-btn>
            <v-spacer></v-spacer>
            <v-text-field label="Search" outlined dense v-model="searchCompleteOrders" v-on:keyup.enter="
          $router.push({
            name: $route.name,
            query: {
              resolvedOffset: $route.query.resolvedOffset,
              resolvedSearch: searchCompleteOrders,
              records: $route.query.records,
            },
          })
        "></v-text-field>
        </v-toolbar>
        <div v-if="selectedOrderSubTab!='completed'">

            <v-data-table :loading="loading" :key="selectedOrderSubTab" :search="selectedOrderSubTab=='completed'?null:searchOrders" :items="filteredOpenTab" :headers="headers" :rows-per-page-items="[15, 25, 50, 100]" style="cursor: pointer">
                <template v-slot:items="props">
                    <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
                        {{ props.item.id }}
                    </td>
                    <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
                        {{ formatDate(props.item.createdAt) }}<br><span class="grey--text">{{ formatTime(props.item.createdAt) }}</span>
                    </td>
                    <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
                        {{ formatDate(props.item.updatedAt) }}
                    </td>
  <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
                            <span v-if="props.item.customerOrganisation">{{props.item.customerOrganisation.name}}</span>
                        </td>
                    <td v-if="props.item.locationId" class="text-xs-center" @click="routerLinkToDetails(props.item)">
                        {{ props.item.location.locationDescription }}
                    </td>
                    <td v-else class="text-xs-center" @click="routerLinkToDetails(props.item)">
                        {{ formattedAddress(props.item) }}
                    </td>
                    <td @mouseover="selectItem(props.item)" @mouseleave="selectedItem = {}" class="text-xs-center" @click="routerLinkToDetails(props.item)">
                        <v-menu v-if="
                props.item.tickets.length > 0
              " open-on-hover top offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-chip v-bind="attrs" v-on="on" color="success" class="white--text">{{
                    props.item.tickets.length
                  }}
                                </v-chip>
                            </template>

                            <v-card v-if="
                  props.item === selectedItem &&
                    props.item.tickets.length>0
                " flat>
                                <v-flex v-for="ticket in props.item.tickets" :key="ticket.id">
                                    <v-card v-on="on" hover flat width="300px">
                                        <v-layout justify-center>
                                            <v-flex xs6 text-xs-left>
                                                <h4 class="mx-1 grey--text font-weight-bold">ID:</h4>
                                            </v-flex>
                                            <v-flex xs6 text-xs-left>
                                                <h4 class=" grey--text font-weight-light">{{ ticket.id }}</h4>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout justify-center v-if="ticket.ticketCategoryItem">
                                            <v-flex xs6 text-xs-left>
                                                <h4 class="mx-1 grey--text font-weight-bold">Subcategory:</h4>
                                            </v-flex>
                                            <v-flex xs6 text-xs-left>
                                                <h4 class="grey--text font-weight-light">{{ ticket.ticketCategoryItem.name }}</h4>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout justify-center align-center>
                                            <v-flex xs6 text-xs-left>
                                                <h4 class="mx-1 grey--text font-weight-bold">Status:</h4>
                                            </v-flex>
                                            <v-flex xs6 text-xs-left>
                                                <h4 class="grey--text">
                                                    <v-chip small :class="`${ticket.currentStatus.replace(/\s/g, '').toLowerCase()} white--text`">{{ ticket.currentStatus }}</v-chip>
                                                </h4>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout justify-center align-center>
                                            <v-flex xs6 text-xs-left>
                                                <h4 class="mx-1 grey--text font-weight-bold">Due date:</h4>
                                            </v-flex>
                                            <v-flex xs6 text-xs-left>
                                                <v-span class="grey--text">{{ formatDate(ticket.dueDate) }}</v-span>
                                            </v-flex>
                                        </v-layout>
                                    </v-card>
                                    <v-divider></v-divider>
                                </v-flex>
                            </v-card>
                        </v-menu>
                        <v-chip v-else color="grey" class="white--text">0</v-chip>
                    </td>

                    <td class="text-xs-center" v-if="props.item.primaryContactTitle !== null" @click="routerLinkToDetails(props.item)">
                        {{
              props.item.primaryContactTitle +
                " " +
                props.item.primaryContactFirstname +
                " " +
                props.item.primaryContactLastname
            }}
                    </td>
                    <td class="text-xs-center" v-else @click="routerLinkToDetails(props.item)">
                        {{ props.item.primaryContactFirstname + " " + props.item.primaryContactLastname }}
                    </td>

                    <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
                        {{ props.item.primaryContactMobileNumber }}
                    </td>
                    <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
                        {{ props.item.primaryContactEmailAddress }}
                    </td>
                    <td v-if="props.item.notes" class="text-xs-center" @click="routerLinkToDetails(props.item)">
                        {{ props.item.notes.comment + " " + formatDateTime(props.item.notes.createdAt) }}
                    </td>
                    <td v-else class="text-xs-center" @click="routerLinkToDetails(props.item)"></td>
                </template>
            </v-data-table>
            <div v-if="selectedOrderSubTab=='completed'" class="text-xs-center pt-2 white" :key="$route.query.resolvedOffset">
                <v-layout wrap>
                    <v-flex xs12>
                        <v-pagination v-model="resolvedPage" :length="Math.ceil(resolvedApplications.count / $route.query.records)" :total-visible="7"></v-pagination>
                    </v-flex>
                </v-layout>
            </div>
        </div>
            <div v-else>

                <v-data-table :loading="loading" :key="selectedOrderSubTab" :items="filteredOpenTab" :headers="completedHeaders" :rows-per-page-items="[15, 25, 50, 100]" style="cursor: pointer" hide-actions>
                    <template v-slot:items="props">
                        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
                            <v-chip v-if="!props.item.isDenied" color="green" class="white--text">Accepted</v-chip>
                            <v-chip v-else color="red" class="white--text">Denied</v-chip>

                        </td>
                        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
                            {{ props.item.id }}
                        </td>
                        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
                            {{ formatDate(props.item.createdAt) }}<br><span class="grey--text">{{ formatTime(props.item.createdAt) }}</span>
                        </td>
                      
                        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
                            {{ formatDate(props.item.updatedAt) }}
                        </td>

                        <td v-if="props.item.locationId" class="text-xs-center" @click="routerLinkToDetails(props.item)">
                            {{ props.item.location.locationDescription }}
                        </td>
                        <td v-else class="text-xs-center" @click="routerLinkToDetails(props.item)">
                            {{ formattedAddress(props.item) }}
                        </td>
                        <td class="text-xs-center" v-if="props.item.primaryContactTitle !== null" @click="routerLinkToDetails(props.item)">
                            {{
              props.item.primaryContactTitle +
                " " +
                props.item.primaryContactFirstname +
                " " +
                props.item.primaryContactLastname
            }}
                        </td>
                        <td class="text-xs-center" v-else @click="routerLinkToDetails(props.item)">
                            {{ props.item.primaryContactFirstname + " " + props.item.primaryContactLastname }}
                        </td>

                        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
                            {{ props.item.deniedReason}}
                        </td>
                    </template>
                </v-data-table>
                <div class="text-xs-center pt-2 white" :key="$route.query.resolvedOffset">
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-pagination v-model="resolvedPage" :length="Math.ceil(resolvedApplications.count / $route.query.records)" :total-visible="7"></v-pagination>
                        </v-flex>
                    </v-layout>
            </div>
            </div>

        </div>
        <div v-else-if="displayMainTab('showOfInterest')">
            <v-toolbar flat color="white">
                <div>
                    <applicationpagemodal @submitComplete="fetchOrders()"></applicationpagemodal>
                </div>
                <v-btn class="white--text" :color="$store.state.currentOrg.org.primaryColour" round @click="exportCompletedData()">Export Completed Orders</v-btn>
                <v-spacer></v-spacer>
                <v-text-field label="Search" outlined dense v-model="searchLeads"></v-text-field>
            </v-toolbar>
            <v-data-table :loading="loading" :items="allShowOfInterest.result" :search="searchLeads" :headers="showOfInterestHeaders" :rows-per-page-items="[15, 25, 50, 100]" style="cursor: pointer">
                <template v-slot:items="props">
                    <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
                        {{ props.item.id }}
                    </td>
                    <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
                        {{ formatDate(props.item.createdAt) }}<br><span class="grey--text">{{ formatTime(props.item.createdAt) }}</span>
                    </td>
                    <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
                        {{ formatDate(props.item.updatedAt) }}
                    </td>

                    <td v-if="props.item.locationId" class="text-xs-center" @click="routerLinkToDetails(props.item)">
                        {{ props.item.location.locationDescription }}
                    </td>
                    <td v-else class="text-xs-center" @click="routerLinkToDetails(props.item)">
                        {{ formattedAddress(props.item) }}
                    </td>

                    <td class="text-xs-center" v-if="props.item.primaryContactTitle !== null" @click="routerLinkToDetails(props.item)">
                        {{
              props.item.primaryContactTitle +
                " " +
                props.item.primaryContactFirstname +
                " " +
                props.item.primaryContactLastname
            }}
                    </td>
                    <td class="text-xs-center" v-else @click="routerLinkToDetails(props.item)">
                        {{ props.item.primaryContactFirstname + " " + props.item.primaryContactLastname }}
                    </td>

                    <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
                        {{ props.item.primaryContactMobileNumber }}
                    </td>
                    <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
                        {{ props.item.primaryContactEmailAddress }}
                    </td>
                    <td v-if="props.item.notes" class="text-xs-center" @click="routerLinkToDetails(props.item)">
                        {{ props.item.deniedReason }}
                    </td>
                    <td v-else class="text-xs-center" @click="routerLinkToDetails(props.item)"></td>
                </template>
            </v-data-table>

        </div>
        <div v-else-if="displayMainTab('rejected')">
            <v-toolbar flat color="white">
                <div>
                    <applicationpagemodal @submitComplete="fetchOrders()"></applicationpagemodal>
                </div>
                <v-btn class="white--text" :color="$store.state.currentOrg.org.primaryColour" round @click="exportCompletedData()">Export Completed Orders</v-btn>
                <v-spacer></v-spacer>
                <v-text-field label="Search" outlined dense v-model="searchRejected"></v-text-field>
            </v-toolbar>
        </div>

        <v-dialog v-model="applicationModal" width="1500px">
             <v-toolbar flat color="primary">
                 <v-toolbar-title class="white--text">New Order</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat color="white" @click="applicationModal=false">X</v-btn>
            </v-toolbar>
            <v-card>
                <v-card-text>
                    <applicationPageModalNew @submitted="applicationModal=false, fetchOrders()" />
                </v-card-text>
            </v-card>
           
        </v-dialog>
    </div>
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
import applicationPageModal from "@/components/ApplicationPageModal.vue";
import applicationPageModalNew from "@/components/applicationPage/FTTHApplicationPage.vue";

export default {
    components: {
        applicationpagemodal: applicationPageModal,
        applicationPageModalNew
    },
    data() {
        return {
            allActiveOrders: {
                count: 0,
                result: []
            },
            allShowOfInterest: {
                count: 0,
                result: []
            },
            allRejectedOrders: {
                count: 0,
                result: []
            },
            allPendingActivation: {
                count: 0,
                result: []
            },
            resolvedApplications: {
                count: 0,
                result: []
            },
            resolvedPage: 1,
            resolvedPagination: {
                sortBy: "createdAt",
                descending: true
            },
            applicationModal: false,
            initialResolvedLoad: 0,
            loading: false,
            headers: [{
                    text: "ID",
                    align: "center",
                    value: "id",
                },
                {
                    text: "Submitted",
                    align: "center",
                    value: "createdAt",
                },
                {

                    text: "Last Updated",
                    align: "center",
                    value: "updatedAt",
                },{
                    text: "ISP",
                    align: "center",
                    value: "customerOrganisation.name"
                },
                // {
                //     text: "ISP",
                //     align: "center",
                //     value: "customerOrganisation.name"
                // },

                {
                    text: "Location",
                    align: "center",
                    value: "location.locationDescription",
                    sortable: false,
                },
                {
                    text: "Open Tickets",
                    align: "center",
                    value: "openTickets"
                },
                {
                    text: "Contact Name",
                    align: "center",
                    value: "primaryContactFirstname"
                },
                {
                    text: "Mobile Number",
                    align: "center",
                    value: "primaryContactMobileNumber"
                },
                {
                    text: "Email Address",
                    align: "center",
                    value: "primaryContactEmailAddress"
                },
                {
                    text: "Latest Note",
                    align: "center",
                    value: "notes",
                    sortable: false,
                },
            ],
            showOfInterestHeaders: [{
                    text: "ID",
                    align: "center",
                    value: "id",
                },
                {
                    text: "Submitted",
                    align: "center",
                    value: "createdAt",
                },
                {

                    text: "Last Updated",
                    align: "center",
                    value: "updatedAt",
                },
 
                {
                    text: "Location",
                    align: "center",
                    value: "location.locationDescription",
                    sortable: false,
                },
                {
                    text: "Contact Name",
                    align: "center",
                    value: "primaryContactFirstname"
                },
                {
                    text: "Mobile Number",
                    align: "center",
                    value: "primaryContactMobileNumber"
                },
                {
                    text: "Email Address",
                    align: "center",
                    value: "primaryContactEmailAddress"
                },
                {
                    text: "Latest Note",
                    align: "center",
                    value: "notes",
                    sortable: false,
                },
            ],
            completedHeaders: [{
                    text: "Status",
                    align: "center",
                    value: "isDenied",
                },
                {
                    text: "ID",
                    align: "center",
                    value: "id",
                },
                {
                    text: "Submitted",
                    align: "center",
                    value: "createdAt",
                },
                {

                    text: "Last Updated",
                    align: "center",
                    value: "updatedAt",
                },

                {
                    text: "Location",
                    align: "center",
                    value: "location.locationDescription",
                    sortable: false,
                },
                {
                    text: "Contact Name",
                    align: "center",
                    value: "primaryContactFirstname"
                },
                {
                    text: "Reason for Denial",
                    align: "center",
                    value: "deniedReason",
                    sortable: false,
                },
            ],
            mainTabs: [{
                    displayName: 'Orders',
                    name: 'orders'
                },
                {
                    displayName: 'Show of Interest',
                    name: 'showOfInterest'
                },
                // {
                //     displayName: 'Rejected',
                //     name: 'rejected'
                // }
            ],
            orderSubTabs: [{
                    displayName: 'New Orders',
                    name: 'newOrders'
                },
                {
                    displayName: 'In Progress',
                    name: 'inProgress'
                },
                {
                    displayName: 'Awaiting Installation',
                    name: 'awaitingInstallation'
                },
                {
                    displayName: 'ISP Approval',
                    name: 'ispApproval'
                },
                {
                    displayName: 'FNO Approval',
                    name: 'fnoApproval'
                },
                {
                    displayName: 'Pending Activation',
                    name: 'pendingActivation'
                },
                {
                    displayName: 'Completed',
                    name: 'completed'
                }
            ],
            selectedMainTab: 'orders',
            selectedOrderSubTab: 'newOrders',
            selectedItem: {},
            searchCompleteOrders: '',
            searchOrders: '',
            searchLeads: '',
            searchRejected: '',

        }
    },
    watch: {
        "resolvedPagination.sortBy": {
            immediate: true,
            handler(value) {
                if (value !== "" && value != null && this.initialResolvedLoad > 0) {
                    this.resolvedPage = 1;
                    this.initialResolvedLoad++;
                    Api()
                        .get("/applications/all/resolved", {
                            params: {
                                offset: "0",
                                search: this.$route.query.resolvedSearch,
                                records: this.$route.query.records,
                                sortBy: this.resolvedPagination.sortBy,
                                descending: this.resolvedPagination.descending ? "DESC" : "ASC",
                            },
                        })
                        .then((response) => {
                            this.resolvedApplications = response.data
                            this.key++;
                            this.isLoading = false;
                        });
                }
            },
        },
        "resolvedPagination.descending": {
            immediate: true,
            handler(value) {
                if (value !== "" && value != null && this.initialResolvedLoad > 0) {
                    this.resolvedPage = 1;
                    this.initialResolvedLoad++;
                    Api()
                        .get("/applications/all/resolved", {
                            params: {
                                offset: "0",
                                search: this.$route.query.resolvedSearch,
                                records: this.$route.query.records,
                                sortBy: this.resolvedPagination.sortBy,
                                descending: this.resolvedPagination.descending ? "DESC" : "ASC",
                            },
                        })
                        .then((response) => {
                            this.resolvedApplications = response.data
                            this.key++;
                            //this.resolvedPagination={}
                            this.isLoading = false;
                        });
                }
            },
        },
        // Resolved
        "$route.query.resolvedSearch": {
            immediate: true,
            handler(value) {
                this.isLoading = true;
                if (this.$route.query.resolvedSearch && value !== "" && value != null && this.initialResolvedLoad > 0) {
                    this.resolvedPage = 1;
                    this.initialResolvedLoad++;
                    Api()
                        .get("/applications/all/resolved", {
                            params: {
                                search: this.$route.query.resolvedSearch,
                                offset: "0",
                                records: this.$route.query.records,
                                sortBy: this.resolvedPagination.sortBy,
                                descending: this.resolvedPagination.descending ? "DESC" : "ASC",
                            },
                        })
                        .then((response) => {
                            this.resolvedApplications = response.data
                            this.key++;
                            this.isLoading = false;
                        });
                } else if (this.$route.query.resolvedOffset != "undefined" && this.initialResolvedLoad > 0) {
                    this.initialResolvedLoad++;
                    Api()
                        .get("/applications/all/resolved", {
                            params: {
                                offset: this.$route.query.resolvedOffset,
                                records: this.$route.query.records,
                                sortBy: this.resolvedPagination.sortBy,
                                descending: this.resolvedPagination.descending ? "DESC" : "ASC",
                            },
                        })
                        .then((response) => {
                            this.resolvedApplications = response.data
                            this.key++;
                            this.isLoading = false;
                        });
                }
                this.key++;
            },
        },
        "$route.query.resolvedOffset": {
            immediate: true,
            handler(value) {
                this.isLoading = true;
                if (
                    value !== "" &&
                    value != null &&
                    this.$route.query.resolvedSearch &&
                    this.$route.query.resolvedSearch != "" &&
                    this.$route.query.resolvedSearch !== null &&
                    this.$route.query.resolvedSearch !== "undefined" &&
                    this.initialResolvedLoad > 0
                ) {
                    Api()
                        .get("/applications/all/resolved", {
                            params: {
                                search: this.$route.query.resolvedSearch,
                                offset: this.$route.query.resolvedOffset,
                                records: this.$route.query.records,
                                sortBy: this.resolvedPagination.sortBy,
                                descending: this.resolvedPagination.descending ? "DESC" : "ASC",
                            },
                        })
                        .then((response) => {
                            this.resolvedApplications = response.data
                            this.key++;
                            this.isLoading = false;
                        });
                } else if (value != null && value != "undefined") {
                    this.initialResolvedLoad++;
                    Api()
                        .get("/applications/all/resolved", {
                            params: {
                                offset: this.$route.query.resolvedOffset,
                                records: this.$route.query.records,
                                sortBy: this.resolvedPagination.sortBy,
                                descending: this.resolvedPagination.descending ? "DESC" : "ASC",
                            },
                        })
                        .then((response) => {
                            this.resolvedApplications = response.data
                            this.key++;
                            this.isLoading = false;
                        });
                }
                this.key++;
            },
        },
        resolvedPage(value) {
            //this.resolvedPagination.page = this.resolvedPage;
            if (value && value != "" && value != this.$route.query.records) {
                if (this.$route.query.resolvedSearch) {
                    this.$router.push({
                        name: this.$route.name,
                        query: {
                            records: this.$route.query.records,
                            resolvedOffset: (value - 1) * this.$route.query.records,
                            pendingOffset: this.$route.query.pendingOffset,
                            resolvedSearch: this.$route.query.resolvedSearch,
                            pendingSearch: this.$route.query.pendingSearch,
                        },
                    });
                } else {
                    this.$router.push({
                        name: this.$route.name,
                        query: {
                            records: this.$route.query.records,
                            resolvedOffset: (value - 1) * this.$route.query.records,
                            pendingOffset: this.$route.query.pendingOffset,
                            pendingSearch: this.$route.query.pendingSearch,
                        },
                    });
                }
            }
        },
    },
    computed: {
        filteredOpenTab() {
            let result = this.getFilteredData(this.selectedOrderSubTab)

            return result
        }
    },
    created() {
        this.fetchOrders()
        this.$router.push({
            name: this.$route.name,
            query: {
                pendingOffset: "0",
                resolvedOffset: "0",
                records: "15",
            },
        });
    },
    methods: {
        displayMainTab(val) {
            return this.selectedMainTab == val
        },
        async fetchOrders() {
            this.loading = true
            await  Api().get('/applications/open/orders').then(response => {
                this.allActiveOrders = response.data
            })
            await Api().get('/applications/open/pendingActivation').then(response => {
                this.allPendingActivation = response.data
            })
           await Api().get('/applications/open/showOfInterest').then(response => {
                this.allShowOfInterest = response.data
            })
            this.loading = false
        },
        exportCompletedData() {
            Api()
                .get("/applications/resolved/export")
                .then((response) => {
                    var hiddenElement = document.createElement("a");
                    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(response.data);
                    hiddenElement.target = "_blank";
                    hiddenElement.download = "completed_orders.csv";
                    hiddenElement.click();
                });
        },
        formatDate(date) {
            if (date !== null) {
                return dateformat(date, "dd/mm/yyyy");
            } else {
                null;
            }
        },
        formatTime(date) {
            return date ? dateformat(date, "HH:MM") : "";
        },
        formatDateTime(date) {
            if (date !== null) {
                return dateformat(date, "yyyy-mm-dd HH:MM");
            } else {
                null;
            }
        },
        getFilteredData(type) {
            if (type == 'newOrders') {
                return this.allActiveOrders.result.filter((el) =>
                    !el.isContactVerified &&
                    !el.isInstallVerified &&
                    !el.isDeviceVerified &&
                    !el.ispAccepted 
                )
            } else if(type == 'inProgress'){
                return this.allActiveOrders.result.filter((el) =>
                !this.getFilteredData('awaitingInstallation').map(x=>x.id).includes(el.id)&&
                   ((el.isContactVerified &&
                    !el.isInstallVerified &&
                    !el.isDeviceVerified ) ||(!el.isContactVerified &&
                    el.isInstallVerified &&
                    el.isDeviceVerified ))
                )
            }
            else if (type == 'awaitingInstallation') {
                return this.allActiveOrders.result.filter((el) =>
                    el.isContactVerified &&
                    el.tickets.length > 0 &&
                    !el.isInstallVerified &&
                    !el.isDeviceVerified &&
                    !el.ispAccepted 
                )
            } else if (type == 'ispApproval') {
                return this.allActiveOrders.result.filter((el) =>
                    el.isContactVerified && el.customerOrganisationId &&
                    el.isInstallVerified &&
                    el.isDeviceVerified &&
                    !el.ispAccepted 
                )
            } else if (type == 'fnoApproval') {
                return this.allActiveOrders.result.filter((el) =>
                    el.isContactVerified &&
                    el.isInstallVerified &&
                    el.isDeviceVerified &&
                    !el.isApproved &&
                    ((el.customerOrganisationId && el.ispVerified && el.ispAccepted) || (!el.customerOrganisationId && !el.ispAccepted))
                )
            } else if (type == 'pendingActivation') {
                return this.allPendingActivation.result
            } else if (type == 'completed') {
                console.log(this.resolvedApplications)
                return this.resolvedApplications.result
            }
        },
        formattedAddress(val) {
            let address = ''
            if (val.unitNo) {
                address += 'Unit ' + val.unitNo + ', '
            }
            if (val.floorNo) {
                address += 'Floor ' + val.floorNo + ', '
            }
            if (val.building) {
                address += val.building + ', '
            }
            if (val.streetNumber) {
                address += val.streetNumber + ' '
            }
            if (val.streetName) {
                address += val.streetName + ', '
            }
            if (val.suburb) {
                address += val.suburb + ', '
            }
            if (val.town) {
                address += val.town + ', '
            }
            if (val.province) {
                address += val.province + ', '
            }
            if (val.country) {
                address += val.country
            }
            if (val.postalCode) {
                address += ' ' + val.postalCode
            }
            return address
        },
        getOpenOrderCount(type) {
            if (type == 'newOrders') {
                return this.allActiveOrders.result.filter((el) =>
                    !el.isContactVerified &&
                    !el.isInstallVerified &&
                    !el.isDeviceVerified &&
                    !el.ispAccepted 
                ).length
            }  else if(type == 'inProgress'){
                return this.allActiveOrders.result.filter((el) =>
                !this.getFilteredData('awaitingInstallation').map(x=>x.id).includes(el.id)&&
                    ((el.isContactVerified &&
                    !el.isInstallVerified &&
                    !el.isDeviceVerified ) ||(!el.isContactVerified &&
                    el.isInstallVerified &&
                    el.isDeviceVerified ))
                ).length
            } else if (type == 'awaitingInstallation') {
                return this.allActiveOrders.result.filter((el) =>
                    el.isContactVerified &&
                    el.tickets.length > 0 &&
                    !el.isInstallVerified &&
                    !el.isDeviceVerified &&
                    !el.ispAccepted &&
                    !el.fnoAccepted
                ).length
            } else if (type == 'ispApproval') {
                return this.allActiveOrders.result.filter((el) =>
                    el.isContactVerified && el.customerOrganisationId &&
                    el.isInstallVerified &&
                    el.isDeviceVerified &&
                    !el.ispAccepted &&
                    !el.fnoAccepted
                ).length
            } else if (type == 'fnoApproval') {
                return this.allActiveOrders.result.filter((el) =>
                    el.isContactVerified &&
                    el.isInstallVerified &&
                    el.isDeviceVerified &&
                    !el.isApproved &&
                    ((el.customerOrganisationId && el.ispVerified && el.ispAccepted) || (!el.customerOrganisationId && !el.ispAccepted))
                ).length
            } else if (type == 'pendingActivation') {
                return this.allPendingActivation.count
            } else if (type == 'completed') {
                return this.resolvedApplications.count
            }
        },

        async routerLinkToDetails(item) {
            if (item.type == "Order" && item.supplierOrganisationId === this.$store.state.currentOrg.org.id) {
                let route = await this.$store.state.currentOrg.org.permissions.filter(function (el) {
                    return el.url === "/applications/:applicationId";
                });
                await this.$store.dispatch("setCurrentRoute", route[0]);
                this.editedItem = Object.assign({}, item);
                this.$router.push({
                    path: "/applications/" + this.editedItem.id
                });
            } else if (item.type != "Order" && item.supplierOrganisationId === this.$store.state.currentOrg.org.id) {
                let route = await this.$store.state.currentOrg.org.permissions.filter(function (el) {
                    return el.url === "/applications/lead/:applicationId";
                });
                await this.$store.dispatch("setCurrentRoute", route[0]);
                this.editedItem = Object.assign({}, item);
                this.$router.push({
                    path: "/applications/lead/" + this.editedItem.id
                });
            } else if (item.customerOrganisationId === this.$store.state.currentOrg.org.id) {
                let route = await this.$store.state.currentOrg.org.permissions.filter(function (el) {
                    return el.url === "/ispApplications/:applicationId";
                });
                await this.$store.dispatch("setCurrentRoute", route[0]);
                this.editedItem = Object.assign({}, item);
                this.$router.push({
                    path: "/ispApplications/" + this.editedItem.id
                });
            } else if (item.organisationId === this.$store.state.currentOrg.org.id) {
                let route = await this.$store.state.currentOrg.org.permissions.filter(function (el) {
                    return el.url === "/virtualOwnerApplication/:applicationId";
                });
                await this.$store.dispatch("setCurrentRoute", route[0]);
                this.editedItem = Object.assign({}, item);
                this.$router.push({
                    path: "/virtualOwnerApplication/" + this.editedItem.id
                });
            }
        },

        selectItem(item) {
            this.selectedItem = item;
        },
    },
}
</script>
